module.exports = __webpack_public_path__ + "img/nfts-page-bg.838944d9.webp";